// import 'babel-polyfill'
import Vue from "vue";
import VueJamIcons from "vue-jam-icons";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import * as VueGoogleMaps from "vue2-google-maps";
import Carousel3d from "vue-carousel-3d";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import VueAgile from "vue-agile";
import VModal from "vue-js-modal";
import VueLodash from "vue-lodash";
import lodash from "lodash";
import VueObserveVisibility from "vue-observe-visibility";

import "@/mixins/mixins";

// Custom variables bootstrap

// PurgeCSS'd bootstrap files
import '../src/assets/bootstrap/css/extra-bootstrap-module.css'
import '../src/assets/bootstrap/css/bootstrap-vue.css'

// Full bootstrap files
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";


Vue.config.productionTip = false;
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyC_Hm_-Jn3LjM2X3JHOY2igcR6l7JyIxgQ",
    libraries: "places", // This is required if you use the Autocomplete plugin
    region: "NL",
    language: "nl",
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  ////
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
});
Vue.use(BootstrapVue);
Vue.use(VueJamIcons);
Vue.component("GmapCluster", GmapCluster);
Vue.use(VueAgile);
Vue.use(Carousel3d);
Vue.use(IconsPlugin);
Vue.use(VModal);
Vue.use(VueLodash, { lodash: lodash });
Vue.use(VueLodash, { _: lodash });
Vue.use(VueObserveVisibility);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
